import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/login',
    name: 'Login',
    meta: { ignoreAuth: true, title: 'LOGIN | Bayarind Single Dashboard' },
    component: () => import('../pages/Auth/Login.vue'),
  },
  {
    path: '/registration',
    name: 'Register',
    meta: { ignoreAuth: true, title: 'Form Registration' },
    component: () => import('../pages/Auth/Registration/Registration.vue'),
  },
  {
    path: '/confirmationpage',
    name: 'Register Confirmation Page',
    meta: { ignoreAuth: true, title: 'Register Confirmation Page', isSent: true },
    component: () => import('../pages/Auth/Registration/Registration.vue'),
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    meta: { ignoreAuth: true },
    component: () => import('../pages/Auth/ForgotPassword.vue'),
  },
  {
    path: '/login/verify',
    name: 'TwoFactorAuthorization',
    meta: { ignoreAuth: true },
    props: true,
    component: () => import('../pages/Auth/TwoFactorAuth.vue'),
  },
  {
    path: '/change-password/:token',
    name: 'ChangePassword',
    meta: { ignoreAuth: true },
    component: () => import('../pages/Auth/ChangePassword.vue'),
  },
  {
    path: '/verify-user/:token',
    name: 'VerifyPassword',
    meta: { ignoreAuth: true },
    component: () => import('../pages/Auth/VerifyPassword.vue'),
  },
  {
    path: '/confirmation/:token',
    name: 'Confirmation',
    meta: { ignoreAuth: true },
    component: () => import('../pages/Auth/Registration/Confirmation.vue'),
  },
  {
    path: '/locked',
    name: 'Locked',
    props: true,
    meta: { ignoreAuth: true },
    component: () => import('../pages/Auth/Locked.vue'),
  },
  {
    path: '/complete-registration/:token?',
    name: 'CompleteRegistration',
    meta: { ignoreAuth: true },
    component: () => import('../pages/Auth/CompleteRegistration.vue'),
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('@/components/Layout.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../pages/Home.vue'),
      },
      {
        path: 'payment-gateway/transaction-report',
        name: 'PaymentGateway',
        component: () => import('@/components/EmptyLayout.vue'),
        children: [
          {
            path: 'credit-card/:tb/:id',
            name: 'CreditCardReportDetail',
            component: () => import('../pages/Payment/CreditCard/CreditCardReportDetail.vue'),
          },
          {
            path: 'credit-card',
            name: 'CreditCardReportList',
            component: () => import('../pages/Payment/CreditCard/CreditCardReport.vue'),
          },
          {
            path: 'online-transfer/bca',
            name: 'BCAVirtualAccountWrapper',
            component: () => import('../pages/Payment/BCAVirtualAccountReport.vue'),
            redirect: 'online-transfer/bca/bca-va',
            children: [
              {
                path: ':channel',
                name: 'BCAVirtualAccountChannel',
                component: () => import('../pages/Payment/Report.vue'),
              },
            ],
          },
          {
            path: 'online-transfer/:channel/:tb/:id',
            name: 'ReportDetailOnlineTransfer',
            component: () => import('../pages/Payment/ReportDetail.vue'),
          },
          {
            path: 'online-transfer/:channel',
            name: 'ReportListOnlineTransfer',
            component: () => import('../pages/Payment/Report.vue'),
          },
          {
            path: 'internet-banking/:channel/:tb/:id',
            name: 'ReportDetailInstantPayment',
            component: () => import('../pages/Payment/ReportDetail.vue'),
          },
          {
            path: 'internet-banking/:channel',
            name: 'ReportListInstantPayment',
            component: () => import('../pages/Payment/InstantPaymentReport.vue'),
          },
          {
            path: 'instant-payment/:channel/:tb/:id',
            name: 'ReportDetailInstantCredit',
            component: () => import('../pages/Payment/Other/OtherPaymentReportDetail.vue'),
          },
          {
            path: 'instant-credit/:channel/:tb/:id',
            name: 'ReportDetailInstantCredit',
            component: () => import('../pages/Payment/Other/OtherPaymentReportDetail.vue'),
          },
          {
            path: 'instant-credit/:channel',
            name: 'ReportListInstantCredit',
            component: () => import('../pages/Payment/Other/OtherPaymentReport.vue'),
          },
          {
            path: 'e-money/:channel/:tb/:id',
            name: 'ReportDetailEMoney',
            component: () => import('../pages/Payment/Other/OtherPaymentReportDetail.vue'),
          },
          {
            path: 'e-money/:channel',
            name: 'ReportListEMoney',
            component: () => import('../pages/Payment/Other/OtherPaymentReport.vue'),
          },
          {
            path: 'other/:channel/:tb/:id',
            name: 'ReportDetailOther',
            component: () => import('../pages/Payment/Other/OtherPaymentReportDetail.vue'),
          },
          {
            path: 'other/:channel',
            name: 'ReportListOther',
            component: () => import('../pages/Payment/Other/OtherPaymentReport.vue'),
          },
          {
            path: 'retail/:channel/:tb/:id',
            name: 'ReportDetailRetail',
            component: () => import('../pages/Payment/ReportDetail.vue'),
          },
          {
            path: 'retail/:channel',
            name: 'ReportListRetail',
            component: () => import('../pages/Payment/Report.vue'),
          },
        ],
      },
      {
        path: 'billing',
        name: 'Billing',
        component: () => import('@/components/EmptyLayout.vue'),
        children: [
          {
            path: 'recon-data',
            name: 'BillingReconData',
            component: () => import('@/components/EmptyLayout.vue'),
            children: [
              {
                path: 'merchant',
                name: 'BillingReconDataMerchantList',
                component: () => import('@/pages/Billing/ReconData/ReconList.vue'),
              },
              {
                path: 'external',
                name: 'BillingReconDataMerchantList',
                component: () => import('@/pages/Billing/ReconData/ReconListExternal.vue'),
              },
              {
                path: 'merchant/:merchant_code/:credential_code/:periode_slug',
                name: 'BillingReconDataMerchantDetail',
                component: () => import('@/pages/Billing/ReconData/MerchantDetail/MerchantDetail.vue'),
              },
              {
                path: 'external/:merchant_code/:credential_code/:recon_id',
                name: 'BillingReconDataExternalDetail',
                component: () => import('@/pages/Billing/ReconData/ExternalDetail/ExternalDetail.vue'),
              },
              {
                path: 'internal',
                name: 'BillingReconDataInternalList',
                component: () => import('@/pages/Billing/ReconData/ReconList.vue'),
              },
              {
                path: 'internal/:merchant_code/:credential_code/:periode_slug',
                name: 'BillingReconDataInternalDetail',
                component: () => import('@/pages/Billing/ReconData/InternalDetail/InternalDetail.vue'),
              },
            ],
          },
          {
            path: 'invoice',
            name: 'BillingInvoice',
            component: () => import('@/pages/Billing/Invoice/Invoice.vue'),
          },
        ],
      },
      // EASY INVOICE
      {
        path: 'easyinvoice',
        name: 'EasyInvoice',
        component: () => import('@/components/EmptyLayout.vue'),
        children: [
          {
            path: 'einvoice',
            name: 'Einvoice',
            component: () => import('@/components/EmptyLayout.vue'),
            children: [
              {
                path: 'createinvoice',
                name: 'BillingReconDataMerchantList',
                component: () => import('@/pages/EasyInvoice/Einvoice/CreateInvoce.vue'),
                redirect: 'createinvoice/re-request',
                children: [
                  {
                    path: 're-request',
                    name: 're-request',
                    component: () => import('../pages/EasyInvoice/Einvoice/TabInvoice/ReRequestEinvoice.vue'),
                  },
                  {
                    path: 'report',
                    name: 'report',
                    component: () => import('../pages/EasyInvoice/Einvoice/TabInvoice/ReportEinvoice.vue'),
                  },
                ],
              },
              {
                path: 'invoicebatch',
                name: 'BillingReconDataMerchantDetail',
                component: () => import('@/pages/EasyInvoice/Einvoice/BatchInvoice.vue'),
              },
              {
                path: 'invoicebatchdetail/:id',
                name: 'BillingReconDataMerchantDetail',
                component: () => import('../pages/EasyInvoice/Einvoice/BatchInvoiceTableDetail.vue'),
              },
            ],
          },
          {
            path: 'etransaction',
            name: 'Etrancation',
            component: () => import('@/components/EmptyLayout.vue'),
            children: [
              {
                path: 'listtransaction',
                name: 'listtransaction',
                component: () => import('@/pages/EasyInvoice/Etransaction/TransactionReport.vue'),
              },
              {
                path: 'listinvoice',
                name: 'listinvoice',
                component: () => import('@/pages/EasyInvoice/Etransaction/InvoiceReport.vue'),
              },
              {
                path: 'invoicedetail/:id',
                name: 'EasyInvoiceEtrancationInvoiceDetail',
                component: () => import('../pages/EasyInvoice/Etransaction/Detail/Invoice.vue'),
              },
              {
                path: 'listbulkinvoice',
                name: 'listbulkinvoice',
                component: () => import('@/pages/EasyInvoice/Etransaction/BulkInvoiceReport.vue'),
              },
              {
                path: 'bulkinvoicedetail/:id',
                name: 'EasyInvoiceEtrancationBulkInvoiceDetail',
                component: () => import('../pages/EasyInvoice/Etransaction/Detail/BulkInvoice.vue'),
              },
            ],
          },
          {
            path: 'configuration',
            name: 'Configuration',
            component: () => import('@/components/EmptyLayout.vue'),
            children: [
              {
                path: 'merchant',
                name: 'merchant',
                component: () => import('../pages/EasyInvoice/Configuration/MerchantReport.vue'),
              },
              {
                path: 'addmerchant',
                name: 'EasyInvoiceConfigurationAddMerchant',
                component: () => import('../pages/EasyInvoice/Configuration/Form/AddMerchant.vue'),
              },
              {
                path: 'editmerchant/:id',
                name: 'EasyInvoiceConfigurationEditMerchant',
                component: () => import('../pages/EasyInvoice/Configuration/Form/EditMerchant.vue'),
              },
              {
                path: 'editconfig/:id',
                name: 'EasyInvoiceConfigurationEditConfig',
                component: () => import('../pages/EasyInvoice/Configuration/Form/EditConfig.vue'),
              },
              {
                path: 'superadminmerchant',
                name: 'superadminmerchant',
                component: () => import('../pages/EasyInvoice/Configuration/SuperAdminMerchantReport.vue'),
              },
              {
                path: 'addsuperadminmerchant',
                name: 'EasyInvoiceConfigurationAddSuperAdminMerchant',
                component: () => import('../pages/EasyInvoice/Configuration/Form/AddSuperAdminMerchant.vue'),
              },
              {
                path: 'sprintuser',
                name: 'sprintuser',
                component: () => import('../pages/EasyInvoice/Configuration/SprintUserReport.vue'),
              },
              {
                path: 'addsprintuser',
                name: 'addsprintuser',
                component: () => import('../pages/EasyInvoice/Configuration/Form/AddSprintUser.vue'),
              },
              {
                path: 'profile',
                name: 'EasyInvoiceProfiles',
                component: () => import('../pages/EasyInvoice/Configuration/ProfileList.vue'),
              },
              {
                path: 'profile/new',
                name: 'EasyInvoiceProfileAdd',
                component: () => import('../pages/EasyInvoice/Configuration/Form/EditProfile.vue'),
              },
              {
                path: 'profile/edit/:id',
                name: 'EasyInvoiceProfileEdit',
                component: () => import('../pages/EasyInvoice/Configuration/Form/EditProfile.vue'),
              },
              {
                path: 'product',
                name: 'EasyInvoiceProducts',
                component: () => import('../pages/EasyInvoice/Configuration/Products/ProductList.vue'),
              },
              {
                path: 'product/new',
                name: 'EasyInvoiceProductAdd',
                component: () => import('../pages/EasyInvoice/Configuration/Products/ProductEditor.vue'),
              },
              {
                path: 'product/edit/:id',
                name: 'EasyInvoiceProductEdit',
                component: () => import('../pages/EasyInvoice/Configuration/Products/ProductEditor.vue'),
              },
              {
                path: 'email',
                name: 'EasyInvoiceEmail',
                component: () => import('../pages/EasyInvoice/Configuration/EmailEditor.vue'),
              },
              {
                path: 'sms',
                name: 'EasyInvoiceSMS',
                component: () => import('../pages/EasyInvoice/Configuration/SMSEditor.vue'),
              },
            ],
          },
        ],
      },
      {
        path: 'auto-disbursement',
        name: 'AutoDisbursement',
        component: () => import('@/components/EmptyLayout.vue'),
        children: [
          {
            path: 'account-statement',
            name: 'AutoDisbursementAccountStatement',
            component: () => import('../pages/Disbursements/AccountStatement.vue'),
          },
          {
            path: 'account-statement/:id',
            name: 'AutoDisbursementAccountStatementDetail',
            component: () => import('../pages/Disbursements/AccountStatementDetail.vue'),
          },
          {
            path: 'upload-request',
            name: 'AutoDisbursementUpload',
            component: () => import('../pages/Disbursements/CustomRequest/CustomRequest.vue'),
            redirect: 'upload-request/upload',
            children: [
              {
                path: 'upload',
                name: 'UploadBasedDisbursementUpload',
                component: () => import('../pages/Disbursements/CustomRequest/UploadData.vue'),
              },
              {
                path: 're-request',
                name: 're-request',
                component: () => import('../pages/Disbursements/CustomRequest/Report/ReRequest.vue'),
              },
              {
                path: 'report',
                name: 'report',
                component: () => import('../pages/Disbursements/CustomRequest/Report/Report.vue'),
              },
            ],
          },
          {
            path: 'upload-request/:id',
            name: 'AutoDisbursementDetail',
            component: () => import('../pages/Disbursements/DisbursementDetail.vue'),
          },
          {
            path: 'approval-checker-request',
            name: 'ApprovalCheckerRequest',
            component: () => import('../pages/Disbursements/CheckerRequest/ApprovalCustomRequest.vue'),
            redirect: 'approval-checker-request/approval',
            children: [
              {
                path: 'approval',
                name: 'approval-checker-custom-request-approval',
                component: () => import('../pages/Disbursements/CheckerRequest/NewRequest.vue'),
              },
              {
                path: 'report',
                name: 'approval-checker-custom-request-report',
                component: () => import('../pages/Disbursements/CheckerRequest/Report.vue'),
              },
            ],
          },
          {
            path: 'approval-request',
            name: 'ApprovalRequest',
            component: () => import('../pages/Disbursements/ApprovalRequest/CustomRequest/ApprovalCustomRequest.vue'),
            redirect: 'approval-request/approval',
            children: [
              {
                path: 'approval',
                name: 'approval-custom-request-approval',
                component: () => import('../pages/Disbursements/ApprovalRequest/CustomRequest/NewRequest.vue'),
              },
              {
                path: 'report',
                name: 'approval-custom-request-report',
                component: () => import('../pages/Disbursements/ApprovalRequest/CustomRequest/Report.vue'),
              },
            ],
          },
          {
            path: 'other-business-report',
            name: 'OtherBusinessReport',
            component: () => import('../pages/Disbursements/OtherBusinessReport/OtherBusinessReport.vue'),
          },
          {
            path: 'other-business-report/:id',
            name: 'OtherBusinessReport',
            // eslint-disable-next-line max-len
            component: () => import('../pages/Disbursements/OtherBusinessReport/OtherBusinessReportDetail.vue'),
          },
        ],
      },
      {
        path: 'pcs/summon',
        name: 'PCS',
        component: () => import('@/pages/PCS/PCS.vue'),
      },
      {
        path: 'bayarind',
        name: 'Bayarind',
        component: () => import('@/components/EmptyLayout.vue'),
        children: [
          {
            path: 'top-up/bankconfiguration/',
            name: 'Bankconfiguration',
            component: () => import('@/components/EmptyLayout.vue'),
            redirect: 'top-up/bankconfiguration/report',
            children: [
              {
                path: 'report',
                name: 'reportBankConfiguration',
                component: () => import('../pages/TopUp/BankConfiguration.vue'),
              },
              {
                path: 'add-bank-configuration',
                name: 'AddBankconfiguration',
                component: () => import('../pages/TopUp/DetailBankConfiguration.vue'),
              },
              {
                path: 'detail-bank-configuration',
                name: 'DetailBankconfiguration',
                component: () => import('../pages/TopUp/DetailBankConfiguration.vue'),
              },
              {
                path: 'edit-bank-configuration/:id',
                name: 'editBankconfiguration',
                component: () => import('../pages/TopUp/DetailBankConfiguration.vue'),
              },
            ],
          },
          {
            path: 'top-up/report-reconciliation',
            name: 'Report Reconciliation',
            component: () => import('../pages/TopUp/ReportRecon.vue'),
          },
          {
            path: 'top-up/reconciliation/',
            name: 'TopUp',
            component: () => import('../pages/TopUp/Index.vue'),
            redirect: 'top-up/reconciliation/upload-data-bank',
            children: [
              {
                path: 'upload-data-bank',
                name: 'UploadDataBank',
                component: () => import('../pages/TopUp/UploadDataBank/index.vue'),
              },
              {
                path: 'match-data',
                name: 'MatchData',
                component: () => import('../pages/TopUp/MatchData.vue'),
              },
              {
                path: 'report',
                name: 'Report',
                component: () => import('../pages/TopUp/Report.vue'),
              },

            ],
          },
        ],
      },
      {
        path: 'auto-disbursement-management',
        name: 'AutoDisbursementManagement',
        component: () => import('@/components/EmptyLayout.vue'),
        children: [
          {
            path: 'bank-service',
            name: 'ManagementBankService',
            component: () => import('../pages/DisbursementsManagement/BankService/MerchantCharge/MerchantCharge.vue'),
            children: [
              {
                path: 'merchant-charge',
                name: 'ManagementMerchantCharge',
                // eslint-disable-next-line max-len
                component: () => import('../pages/DisbursementsManagement/BankService/MerchantCharge/MerchantCharge.vue'),
              },
            ],
          },
          {
            path: 'bank-service/merchant-charge/:client_id/:date',
            name: 'ManagementMerchantChargeDetail',
            // eslint-disable-next-line max-len
            component: () => import('../pages/DisbursementsManagement/BankService/MerchantCharge/MerchantChargeDetail.vue'),
          },
          {
            path: 'merchant-account-statement',
            name: 'MerchantAccountStatement',
            component: () => import('../pages/DisbursementsManagement/MerchantAccountStatement/AccountStatement.vue'),
          },
          {
            path: 'merchant-account-statement/:id',
            name: 'MerchantAccountStatementDetail',
            component: () => import('../pages/DisbursementsManagement/MerchantAccountStatement/StatementDetail.vue'),
          },
          {
            path: 'merchant-balance',
            name: 'MerchantBalance',
            component: () => import('@/pages/DisbursementsManagement/MerchantBalance/BalanceList.vue'),
          },
          {
            path: 'bussiness-list',
            name: 'BussinessList',
            component: () => import('../pages/Disbursements/Bussiness/BussinessList.vue'),
          },
          // {
          //   path: 'bussiness-list/:id',
          //   name: 'BussinessListDetail',
          //   component: () => import('../pages/Disbursements/Bussiness/BussinessDetail.vue'),
          // },
          {
            path: 'bussiness-list/:id/:code',
            name: 'BussinessListDetail',
            component: () => import('../pages/Disbursements/Bussiness/BussinessDetail.vue'),
            redirect: 'bussiness-list/:id/:code/pricing',
            children: [
              {
                path: 'pricing',
                name: 'pricing',
                component: () => import('../pages/Disbursements/Bussiness/BussinessDetailPricing.vue'),
              },
              {
                path: 'configuration',
                name: 'configuration',
                component: () => import('../pages/Disbursements/Bussiness/BussinessDetailConfiguration.vue'),
              },
              {
                path: 'setting',
                name: 'setting',
                component: () => import('../pages/Disbursements/Bussiness/BussinessDetailSetting.vue'),
              },
              {
                path: 'topup',
                name: 'topup',
                component: () => import('../pages/Disbursements/ManualTopup/TopUp.vue'),
              },
            ],
          },
          {
            path: 'bussiness-list/:id/topup',
            name: 'BussinessListManualTopup',
            component: () => import('../pages/Disbursements/ManualTopup/TopUp.vue'),
          },
          {
            path: 'partnership-list',
            name: 'PartnershipList',
            component: () => import('../pages/DisbursementsManagement/Partnership/Partnership.vue'),
          },
          {
            path: 'partnership-list/:id',
            name: 'PartnerPricing',
            component: () => import('../pages/DisbursementsManagement/Partnership/Pricing/Pricing.vue'),
          },
          {
            path: 'auto-flag',
            name: 'AutoFlag',
            // eslint-disable-next-line max-len
            component: () => import('../pages/DisbursementsManagement/AutoFlag/AutoFlag.vue'),
            redirect: 'auto-flag/report',
            children: [
              {
                path: 'report',
                name: 'AutoFlag',
                component: () => import('../pages/DisbursementsManagement/AutoFlag/Report/Report.vue'),
              },
              {
                path: 'upload',
                name: 'Upload',
                component: () => import('../pages/DisbursementsManagement/AutoFlag/Upload/UploadData.vue'),
              },
            ],
          },
          {
            path: 'mapping-bank-code',
            name: 'BankCodeMapping',
            // eslint-disable-next-line max-len
            component: () => import('../pages/DisbursementsManagement/MappingBankCode/Mapping.vue'),
          },
        ],
      },
      {
        path: '/account-management',
        name: 'AccountManagement',
        component: () => import('../pages/AccountManagement/SingleMerchant.vue'),
      },
      {
        path: 'account-management/add',
        name: 'AccountManagementAdd',
        component: () => import('../pages/AccountManagement/SingleMerchantAdd.vue'),
      },
      {
        path: 'account-management/edit/:type',
        name: 'AccountManagementEdit',
        component: () => import('../pages/AccountManagement/SingleMerchantEdit.vue'),
        redirect: 'account-management/edit/:type/information',
        children: [
          {
            path: 'information',
            name: 'information',
            component: () => import('../pages/AccountManagement/Edit/Information.vue'),
          },
          {
            path: 'channels',
            name: 'channels',
            component: () => import('../pages/AccountManagement/Edit/Channels.vue'),
          },
          {
            path: 'reseller',
            name: 'reseller',
            component: () => import('../pages/AccountManagement/Edit/Reseller.vue'),
          },
          {
            path: 'simulator',
            name: 'simulator',
            component: () => import('../pages/AccountManagement/Edit/Simulator.vue'),
          },
        ],
      },
      // START RESELLER//
      {
        path: 'reseller-management',
        name: 'ResellerManagement',
        component: () => import('@/components/EmptyLayout.vue'),
        children: [
          {
            path: 'merchant',
            name: 'merchant',
            component: () => import('../pages/ResellerManagement/Merchant/SingleMerchant.vue'),
          },
          {
            path: 'sub-merchant',
            name: 'sub-merchant',
            component: () => import('../pages/ResellerManagement/SubMerchant/SingleMerchant.vue'),
          },
        ],
      },
      {
        path: 'reseller-management/merchant/add',
        name: 'ResellerManagementAdd',
        component: () => import('../pages/ResellerManagement/Merchant/SingleMerchantAdd.vue'),
      },
      {
        path: 'reseller-management/merchant/edit/:type',
        name: 'ResellerManagementMerchantEdit',
        component: () => import('../pages/ResellerManagement/Merchant/SingleMerchantEdit.vue'),
        redirect: 'reseller-management/merchant/edit/:type/information',
        children: [
          {
            path: 'information',
            name: 'information',
            component: () => import('../pages/ResellerManagement/Merchant/Edit/Information.vue'),
          },
          {
            path: 'pricing',
            name: 'pricing',
            component: () => import('../pages/ResellerManagement/Merchant/Edit/Pricing.vue'),
          },
          {
            path: 'theme',
            name: 'theme',
            component: () => import('../pages/ResellerManagement/Merchant/Edit/Theme.vue'),
          },
          {
            path: 'sub-merchant',
            name: 'sub-merchant',
            component: () => import('../pages/ResellerManagement/Merchant/Edit/SubMerchant.vue'),
          },
        ],
      },
      // END RESELLER//
      {
        path: 'onepay/edit/:user_role/:user_group/:merch_id',
        name: 'OnePayEdit',
        component: () => import('../pages/Onepay/OnepayMerchant/OnepayMerchantEdit.vue'),
        redirect: 'onepay/edit/:user_role/:user_group/:merch_id/information',
        children: [
          {
            path: 'information',
            name: 'information',
            component: () => import('../pages/Onepay/OnepayMerchant/Edit/OnepayMerchantInformation.vue'),
          },
          {
            path: 'channels',
            name: 'channels',
            component: () => import('../pages/Onepay/OnepayMerchant/Edit/OnepayMerchantChannel.vue'),
          },
          {
            path: 'users',
            name: 'users',
            component: () => import('../pages/Onepay/OnepayMerchant/Edit/OnepayMerchantUsers.vue'),
          },
          {
            path: 'setting',
            name: 'setting',
            component: () => import('../pages/Onepay/OnepayMerchant/Edit/OnepayMerchantSetting.vue'),
          },
        ],
      },
      {
        path: '/group-management',
        name: 'GroupManagement',
        component: () => import('@/components/EmptyLayout.vue'),
        children: [
          {
            path: ':type/new',
            name: 'GroupManagementNew',
            component: () => import('../pages/GroupManagement/GroupEditor.vue'),
          },
          {
            path: ':type/detail/:id',
            name: 'GroupManagementDetail',
            component: () => import('../pages/GroupManagement/GroupEditor.vue'),
          },
          {
            path: ':type',
            name: 'GroupManagementInternal',
            component: () => import('../pages/GroupManagement/GroupManagement.vue'),
          },
        ],
      },
      {
        path: 'merchant-lead',
        name: 'MerchantLead',
        component: () => import('../pages/MerchantLead/MerchantLead.vue'),
      },
      {
        path: 'merchant-lead/edit/:type',
        name: 'AccountManagementEdit',
        component: () => import('../pages/MerchantLead/MerchantLeadTab.vue'),
        redirect: 'merchant-lead/edit/:type/information',
        children: [
          {
            path: 'information',
            name: 'information',
            component: () => import('../pages/MerchantLead/LeadTab/Information.vue'),
          },
          {
            path: 'channels',
            name: 'channels',
            component: () => import('../pages/MerchantLead/LeadTab/PaymentChannel/Payment.vue'),
          },
        ],
      },
      {
        path: '/invoice',
        name: 'Invoice',
        component: () => import('@/pages/Invoice/Invoice.vue'),
      },
      {
        path: 'onepay',
        name: 'OnePay',
        component: () => import('@/components/EmptyLayout.vue'),
        children: [
          {
            path: 'onepaydashboard',
            name: 'OnepayDashboard',
            component: () => import('../pages/Onepay/OnepayDashboard/OnepayDashboard.vue'),
          },
          {
            path: 'onepaytransaction',
            name: 'OnepayTransaction',
            component: () => import('../pages/Onepay/OnepayTransaction/OnepayTrans.vue'),
          },
          {
            path: 'onepaytransaction/:trans_no',
            name: 'OnepayTransactionDetail',
            component: () => import('../pages/Onepay/OnepayTransaction/OnepayTransDetail.vue'),
          },
          {
            path: 'onepaymerchant',
            name: 'OnepayMerchant',
            component: () => import('../pages/Onepay/OnepayMerchant/OnepayMerchant.vue'),
          },
          {
            path: 'onepaymerchantmanager',
            name: 'OnepayMerchantManager',
            component: () => import('../pages/Onepay/OnepayMerchantManager/OnepayMerchantmanager.vue'),
          },
        ],
      },
      {
        path: '/bussinesaccount',
        name: 'BussinesAccount',
        component: () => import('@/components/EmptyLayout.vue'),
        children: [
          {
            path: 'bussinesinformation',
            name: 'BussinesInformation',
            component: () => import('../pages/Setting/BusinessInformation/BusinessInformation.vue'),
          },
        ],
      },
      {
        path: '/integration',
        name: 'Integration',
        component: () => import('@/pages/Integration/Integration.vue'),
      },
      {
        path: '/setting',
        name: 'Setting',
        component: () => import('@/components/EmptyLayout.vue'),
        children: [
          {
            path: 'user-management/:type/user/new',
            name: 'UserNew',
            component: () => import('../pages/Setting/UserManagement/UserEditor.vue'),
          },
          {
            path: 'payment-channel',
            name: 'PaymentChannel',
            component: () => import('../pages/Setting/PaymentChannel/Index.vue'),
          },
          {
            path: 'payment-channel-list',
            name: 'PaymentChannelList',
            component: () => import('../pages/Setting/PaymentChannel/list.vue'),
          },
          {
            path: 'user-management/:type/user/:id',
            name: 'UserEdit',
            component: () => import('../pages/Setting/UserManagement/UserEditor.vue'),
          },
          {
            path: 'user-management/:type/role/new',
            name: 'UserRoleNew',
            component: () => import('../pages/Setting/UserManagement/UserRoleEditor.vue'),
          },
          {
            path: 'user-management/:type/role/:id',
            name: 'UserRoleEdit',
            component: () => import('../pages/Setting/UserManagement/UserRoleEditor.vue'),
          },
          {
            path: 'user-management/:type',
            name: 'UserManagement',
            component: () => import('../pages/Setting/UserManagement/UserManagement.vue'),
            redirect: 'user-management/:type/roles',
            children: [
              {
                path: 'roles',
                name: 'UserRoleList',
                component: () => import('../pages/Setting/UserManagement/UserRoleList.vue'),
              },
              {
                path: 'users',
                name: 'UserList',
                component: () => import('../pages/Setting/UserManagement/UserList.vue'),
              },
            ],
          },
          {
            path: 'profile',
            name: 'UserProfile',
            component: () => import('../pages/Setting/UserProfile.vue'),
          },
        ],
      },
      {
        path: '/log-activity/',
        name: 'LogActivity',
        component: () => import('../pages/LogActivity/Log.vue'),
        children: [
          {
            path: 'internal',
            name: 'internal',
            component: () => import('../pages/LogActivity/Log.vue'),
          },
          {
            path: 'external',
            name: 'external',
            component: () => import('../pages/LogActivity/Log.vue'),
          },
          // {
          //   path: 'information',
          //   name: 'information',
          //   component: () => import('../pages/LogActivity/Log.vue'),
          // },
        ],
      },
      {
        path: 'reconciliation',
        name: 'Reconciliation',
        component: () => import('@/components/EmptyLayout.vue'),
        children: [
          {
            path: 'upload/',
            name: 'reconciliationUpload',
            component: () => import('../pages/Reconciliation/Index.vue'),
            redirect: 'upload/file',
            children: [
              {
                path: 'file',
                name: 'reconciliationUploadFile',
                component: () => import('../pages/Reconciliation/UploadIndex.vue'),
              },
              {
                path: 'history',
                name: 'reconciliationUploadHistory',
                component: () => import('../pages/Reconciliation/UploadHistory.vue'),
              },
            ],
          },
          {
            path: 'stg/:templateCode',
            name: 'reconciliationStaging',
            component: () => import('../pages/Reconciliation/Staging.vue'),
          },
          {
            path: 'stg/form/:templateCode',
            name: 'reconciliationStagingForm',
            component: () => import('../pages/Reconciliation/StagingForm.vue'),
          },
          {
            path: 'process/',
            name: 'reconciliationProcess',
            component: () => import('../pages/Reconciliation/Process.vue'),
            redirect: 'process/list',
            children: [
              {
                path: 'list',
                name: 'reconciliationProcessList',
                component: () => import('../pages/Reconciliation/ProcessIndex.vue'),
              },
              {
                path: 'history',
                name: 'reconciliationProcessHistory',
                component: () => import('../pages/Reconciliation/ProcessHistory.vue'),
              },
            ],
          },
        ],
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
